/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Alerts_DescriptionInputs */

const es_billing_alerts_description = /** @type {(inputs: Billing_Alerts_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurá alertas para recibir notificaciones cuando tu gasto mensual se acerque o alcance un valor determinado.`)
};

const en_billing_alerts_description = /** @type {(inputs: Billing_Alerts_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configure alerts to receive notifications when your monthly spend approaches or reaches a defined amount.`)
};

/**
* | output |
* | --- |
* | "Configure alerts to receive notifications when your monthly spend approaches or reaches a defined amount." |
*
* @param {Billing_Alerts_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const billing_alerts_description = /** @type {((inputs?: Billing_Alerts_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Alerts_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_billing_alerts_description(inputs)
	return en_billing_alerts_description(inputs)
});
export { billing_alerts_description as "billing.alerts.description" }